export const ZERITY_VEHICLE_URL = "https://hived.zeritycloud.com/vehicles"
export const INVERS_VEHICLE_URL = "https://fleetcontrol.invers.com/inspect"

// Reasons are a fixed set on the audit log, so they can be spelled out rather than shown raw.
export const FAILURE_REASONS: Record<string, string> = {
  not_clocked_in: "Driver not clocked in",
  no_vehicle_assigned: "No vehicle assigned",
  not_keyless: "Not a keyless vehicle",
  outside_perimeter: "Driver outside perimeter",
  provider_rejected: "Rejected by provider",
  provider_unreachable: "Provider unreachable",
  response_lost: "No response from vehicle",
}
